import * as React from 'react';

import { dollarFormatter } from 'af-utils/format.util';

import styles from './styles.module.scss';

interface Props {
	totalRevenue: number;
	totalSalesMarkup: number;
	payrollDifferentialDeduction: number;
	revenuePerPerson: number;
	fieldEmployees: number;
	totalEmployees: number;
	cumulativeMonthlySalesMarkup: number;
	cumulativeMonthlyBilling: number;
	revenuePerHour: number;
}

const TableHeader: React.FC<Props> = (props) => {

	const {
		totalRevenue,
		totalSalesMarkup,
		payrollDifferentialDeduction,
		revenuePerPerson,
		fieldEmployees,
		totalEmployees,
		cumulativeMonthlySalesMarkup,
		cumulativeMonthlyBilling,
		revenuePerHour,
	} = props;

	return (
		<div className={styles['total-header']}>
			<span>
				# Field Employees/Total Employees:
			</span>
			<b>
				{fieldEmployees}/{totalEmployees}
			</b>
			<span>
				Total Daily Revenue:
			</span>
			<b>
				{dollarFormatter.format(totalRevenue)}
			</b>
			<span>
				Total Daily Material Markup:
			</span>
			<b>
				{dollarFormatter.format(totalSalesMarkup)}
			</b>
			<span>
				Revenue Per Person:
			</span>
			<b>
				{dollarFormatter.format(revenuePerPerson)}
			</b>
			<span>
				Revenue Per Hour:
			</span>
			<b>
				{dollarFormatter.format(revenuePerHour)}
			</b>
			<span>
				Cumulative Monthly Material Markup:
			</span>
			<b>
				{dollarFormatter.format(cumulativeMonthlySalesMarkup)}
			</b>
			<span>
				Cumulative Monthly Billing:
			</span>
			<b>
				{dollarFormatter.format(cumulativeMonthlyBilling)}
			</b>
			{
				process.env.FTD_DISABLE_PR_DIFF !== 'true' && (
					<>
						<span>
							P/R Diff:
						</span>
						<b>
							{dollarFormatter.format(payrollDifferentialDeduction)}
						</b>
					</>
				)
			}
		</div>
	);
};

export default React.memo(TableHeader);
